export enum DestinoLixo {
  QUEIMA_ENTERRADO = 'QUEIMA_ENTERRADO',
  CEU_ABERTO = 'CEU_ABERTO',
  ACONDICIONADO_COLETA = 'ACONDICIONADO_COLETA',
  OUTRO = 'OUTRO',
}
